import { render } from "./Input.vue?vue&type=template&id=c8ead07a&scoped=true&lang=pug"
import script from "./Input.vue?vue&type=script&lang=ts"
export * from "./Input.vue?vue&type=script&lang=ts"

import "./Input.vue?vue&type=style&index=0&id=c8ead07a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c8ead07a"

export default script